{
  "helloWorld": "Hei, maailma!",
  "clickMe": "Klikkaa tästä",
  "healthCheckFailed": "Terveystarkistus epäonnistui",
  "errors": {
    "unexpected": "Odottamaton virhe tapahtui"
  },
  "error": {
    "title": "Jokin meni pieleen",
    "description": "Odottamaton virhe tapahtui. Voit yrittää uudelleen tai palata etusivulle.",
    "tryAgain": "Yritä uudelleen",
    "goHome": "Etusivulle"
  },
  "dev": {
    "errorPreview": "Virheen esikatselu"
  },
  "actions": {
    "label": "Toiminnot",
    "edit": "Muokkaa",
    "delete": "Poista",
    "save": "Tallenna",
    "cancel": "Peruuta",
    "expand": "Laajenna",
    "collapse": "Tiivistä"
  },
  "validation": {
    "tooLong": "Enintään {{max}} merkkiä",
    "tooShort": "Pakollinen",
    "invalidFormat": "Virheellinen muoto",
    "invalid": "Virheellinen arvo"
  },
  "nav": {
    "workspace": "Työtila",
    "controlCenter": "Ohjauskeskus",
    "jobs": "Työpaikat",
    "analytics": "Analytiikka",
    "company": "Yritys",
    "agentCommunications": "Agenttiviestintä",
    "integrations": "Integraatiot",
    "suggestedCandidates": "Ehdotetut hakijat",
    "unsolicitedApplications": "Avoimet hakemukset",
    "team": "Tiimi",
    "templates": "Mallipohjat",
    "workflow": "Työnkulku",
    "settings": "Asetukset",
    "language": "Kieli",
    "help": "Ohje",
    "logout": "Kirjaudu ulos",
    "administration": "Hallinta",
    "adminTenant": "Vuokralaisen asetukset",
    "adminOrganizations": "Organisaatiot",
    "adminDepartments": "Osastot",
    "adminFeedback": "Palaute",
    "openMenu": "Avaa valikko",
    "mcp": "MCP",
    "orgSettings": "Organisaation asetukset"
  },
  "admin": {
    "tenants": {
      "title": "Vuokralaiset",
      "newTenant": "Uusi vuokralainen",
      "columns": {
        "name": "Nimi",
        "createdAt": "Luotu",
        "actions": "Toiminnot"
      },
      "createDialog": {
        "title": "Luo vuokralainen",
        "namePlaceholder": "Acme Corp"
      },
      "editDialog": {
        "title": "Muokkaa vuokralaista"
      }
    },
    "tenant": {
      "title": "Vuokralaisen asetukset",
      "name": "Vuokralaisen nimi",
      "save": "Tallenna muutokset",
      "saved": "Tallennettu"
    },
    "organizations": {
      "title": "Organisaatiot",
      "newOrg": "Uusi organisaatio",
      "columns": {
        "name": "Nimi",
        "slug": "Slug",
        "tenant": "Vuokralainen",
        "createdAt": "Luotu",
        "actions": "Toiminnot",
        "viewWorkspace": "Näytä työtila"
      },
      "createDialog": {
        "title": "Luo organisaatio",
        "namePlaceholder": "Acme Corp",
        "slugPlaceholder": "acme-corp",
        "newTenant": "Uusi vuokralainen",
        "existingTenant": "Olemassa oleva vuokralainen",
        "tenantName": "Vuokralaisen nimi",
        "tenantNamePlaceholder": "Acme Corp",
        "selectTenant": "Valitse vuokralainen"
      },
      "editDialog": {
        "title": "Muokkaa organisaatiota",
        "language": "Kieli",
        "languagePlaceholder": "Valitse kieli"
      },
      "deleteConfirm": {
        "title": "Poista organisaatio",
        "description": "Tämä poistaa myös kaikki tämän organisaation osastot. Tätä toimintoa ei voi kumota.",
        "confirm": "Poista",
        "cancel": "Peruuta"
      }
    },
    "departments": {
      "title": "Osastot",
      "newDept": "Uusi osasto",
      "columns": {
        "name": "Nimi",
        "slug": "Slug",
        "createdAt": "Luotu",
        "actions": "Toiminnot"
      },
      "createDialog": {
        "title": "Luo osasto",
        "namePlaceholder": "Tuotekehitys",
        "slugPlaceholder": "tuotekehitys"
      },
      "editDialog": {
        "title": "Muokkaa osastoa"
      },
      "deleteConfirm": {
        "title": "Poista osasto",
        "description": "Tätä toimintoa ei voi kumota.",
        "confirm": "Poista",
        "cancel": "Peruuta"
      }
    },
    "viewingOrg": {
      "banner": "Katselet: {{name}}",
      "leave": "Poistu"
    },
    "feedback": {
      "title": "Palaute",
      "columns": {
        "rating": "Arvio",
        "modality": "Tyyppi",
        "candidate": "Hakija",
        "job": "Työpaikka",
        "org": "Organisaatio",
        "notes": "Muistiinpanot",
        "date": "Päivämäärä"
      },
      "modality": {
        "voice": "Puhe",
        "text": "Chat"
      },
      "thumbs": {
        "up": "Positiivinen",
        "down": "Negatiivinen"
      },
      "filter": {
        "all": "Kaikki",
        "up": "Positiivinen",
        "down": "Negatiivinen",
        "hasNotes": "Sisältää muistiinpanoja"
      },
      "stats": {
        "title": "Negatiivinen osuus",
        "period": "Viimeiset 7 päivää",
        "wowUp": "+{{delta}}pp",
        "wowDown": "-{{delta}}pp",
        "wowFlat": "Ei muutosta",
        "wowNoPrev": "Ei aiempaa dataa",
        "noData": "Ei dataa"
      },
      "noFeedback": "Ei palautetta vielä",
      "noNotes": "Ei kirjoitettua kommenttia"
    }
  },
  "team": {
    "title": "Tiimi",
    "invite": "Kutsu kollegoita",
    "search": "Hae nimellä, sähköpostilla, osastolla...",
    "department": "Osasto",
    "roles": {
      "admin": "Ylläpitäjä",
      "org_manager": "Organisaation johtaja",
      "dept_manager": "Osaston johtaja",
      "user": "Käyttäjä"
    },
    "columns": {
      "name": "Nimi",
      "email": "Sähköposti",
      "role": "Rooli",
      "actions": "Toiminnot"
    },
    "inviteDialog": {
      "title": "Kutsu kollega",
      "name": "Nimi",
      "namePlaceholder": "Matti Meikäläinen",
      "email": "Sähköpostiosoite",
      "emailPlaceholder": "kollega@yritys.fi",
      "role": "Rooli",
      "departments": "Osastot",
      "submit": "Lähetä kutsu"
    },
    "actions": {
      "changeRole": "Vaihda rooli",
      "addDepartment": "Lisää osastolle",
      "removeDepartment": "Poista osastolta",
      "removeFromOrg": "Poista organisaatiosta"
    },
    "noResults": "Tuloksia ei löytynyt.",
    "noMembers": "Ei tiimin jäseniä vielä."
  },
  "jobs": {
    "title": "Työpaikat",
    "backToJobs": "Työpaikat",
    "newJob": "Uusi työpaikka",
    "createNewJob": "Luo uusi työpaikka",
    "importFromAts": "Tuo kohteesta {{atsName}}",
    "searchPlaceholder": "Hae työpaikkoja...",
    "completedPlaceholder": "{{completed}}/{{total}} valmista",
    "tabs": {
      "active": "Aktiiviset",
      "archived": "Arkistoidut"
    },
    "columns": {
      "name": "Nimi",
      "createdBy": "Luonut",
      "createdAt": "Luotu",
      "actions": "Toiminnot"
    },
    "empty": "Työpaikkoja ei löytynyt.",
    "emptyTitle": "Ei työpaikkoja vielä",
    "emptyDescription": "Luo ensimmäinen työpaikka tai tuo ATS-järjestelmästä aloittaaksesi.",
    "emptyArchivedTitle": "Ei arkistoituja työpaikkoja",
    "emptyArchivedDescription": "Arkistoidut työpaikat näkyvät täällä.",
    "emptySearchDescription": "Yksikään työpaikka ei vastaa hakuasi.",
    "actions": {
      "archive": "Arkistoi",
      "archiveConfirmTitle": "Arkistoi työpaikka",
      "archiveConfirmDescription": "Haluatko varmasti arkistoida tämän työpaikan? Se siirretään Arkistoidut-välilehdelle.",
      "archiveSuccess": "Työpaikka arkistoitu",
      "archiveError": "Työpaikan arkistointi epäonnistui. Yritä uudelleen."
    },
    "createError": "Työpaikan luominen epäonnistui. Yritä uudelleen.",
    "status": {
      "active": "Aktiivinen",
      "archived": "Arkistoitu"
    },
    "setupStatus": {
      "draft": "Luonnos",
      "questions_pending": "Asetukset tarvitaan",
      "ready": "Valmis",
      "active": "Aktiivinen"
    },
    "applicantSync": {
      "syncingBanner": "Haetaan hakijoita kohteesta {{provider}}...",
      "failedBanner": "Hakijoiden synkronointi epäonnistui",
      "adminActions": "Ylläpitotoiminnot",
      "resyncLabel": "Synkronoi hakijat nyt",
      "lastSyncedAt": "Viimeksi synkronoitu: {{date}}",
      "addDemoApplicant": "Lisää demohakija"
    },
    "detail": {
      "tabs": {
        "candidates": "Hakijat",
        "results": "Tulokset",
        "settings": "Asetukset"
      },
      "info": {
        "title": "Työpaikan tiedot",
        "employer": "Työnantaja",
        "location": "Sijainti",
        "description": "Kuvaus",
        "modality": "Haastattelumuoto",
        "languages": "Kielet",
        "atsProvider": "ATS-palveluntarjoaja",
        "atsId": "ATS-työpaikan tunnus",
        "noDescription": "Kuvausta ei ole annettu."
      },
      "questions": {
        "title": "Haastattelukysymykset",
        "empty": "Tälle työpaikalle ei ole määritetty kysymyksiä.",
        "optional": "Valinnainen",
        "categories": {
          "eligibility": "Kelpoisuus",
          "nice_to_have": "Toivottava",
          "job_preview": "Työn odotukset",
          "assessment": "Arviointi",
          "information": "Tiedot"
        }
      }
    }
  },
  "wizard": {
    "step": "Vaihe {{current}}/{{total}}",
    "back": "Takaisin",
    "next": "Jatka",
    "goLive": "Aktivoi",
    "saveAndContinue": "Tallenna ja jatka",
    "manual": {
      "title": "Uusi työpaikka",
      "step1Title": "Perustiedot",
      "step2Title": "Haastattelukysymykset",
      "step3Title": "Vahvista ja aktivoi"
    },
    "import": {
      "title": "Tuo ATS-järjestelmästä",
      "step0Title": "Valitse työpaikat",
      "step1Title": "Yhdistä vaiheet",
      "step2Title": "Haastatteluasetukset",
      "step3Title": "Haastattelukysymykset",
      "step4Title": "Vahvista ja aktivoi"
    },
    "stageSelector": {
      "title": "Yhdistä prosessivaiheet",
      "description": "Valitse kunkin työpaikan vaiheiden vastaavuus Kiku-toimintoihin. Esitäytetty, kun vaiheiden nimet vastaavat oletusasetuksiasi.",
      "continue": "Jatka",
      "loading": "Ladataan vaiheita…"
    },
    "basicInfo": {
      "title": "Työpaikan otsikko",
      "titlePlaceholder": "esim. Vanhempi ohjelmistokehittäjä",
      "description": "Työpaikkakuvaus",
      "descriptionPlaceholder": "Kuvaile rooli, vastuut ja vaatimukset...",
      "descriptionHint": "AI käyttää tätä luodakseen oleelliset haastattelukysymykset",
      "employer": "Työnantajan nimi (valinnainen)",
      "employerPlaceholder": "esim. Acme Corp",
      "modality": "Haastattelumuoto",
      "modalityText": "Tekstikeskustelu",
      "modalityTextDesc": "Hakija kirjoittaa vastauksensa chat-käyttöliittymässä",
      "modalityVoice": "Puhehaastattelu",
      "modalityVoiceDesc": "Live-äänihaastattelu virtuaalisessa kokouksessa",
      "languages": "Haastattelun kieli/kielet",
      "languagesHint": "Valitse vähintään yksi kieli",
      "languagesSearch": "Hae kieliä…",
      "languagesEmpty": "Kieltä ei löytynyt.",
      "modalityRequired": "Valitse vähintään yksi haastattelumuoto",
      "languagesRequired": "Valitse vähintään yksi kieli"
    },
    "atsSelector": {
      "title": "Valitse tuotavat työpaikat",
      "search": "Hae työpaikkoja...",
      "selectAll": "Valitse kaikki",
      "selected": "{{count}} valittu",
      "noJobs": "ATS-järjestelmästäsi ei löytynyt aktiivisia työpaikkoja",
      "noDescription": "Kuvausta ei saatavilla — AI generoi pelkästä otsikosta",
      "continue": "Jatka {{count}} työpaikalla"
    },
    "sharedSettings": {
      "title": "Haastatteluasetukset",
      "subtitle": "Nämä asetukset koskevat kaikkia tuotavia työpaikkoja",
      "employer": "Työnantajan nimi",
      "employerPlaceholder": "esim. Acme Corp"
    },
    "questions": {
      "title": "Haastattelukysymykset",
      "generateError": "Kysymysten generointi epäonnistui. Yritä uudelleen.",
      "retry": "Yritä uudelleen",
      "generating": "Valmistellaan kysymyksiä parhaiden ehdokkaiden löytämiseksi…",
      "generatingHint": "Tämä kestää yleensä muutaman sekunnin",
      "addQuestion": "Lisää kysymys",
      "categories": {
        "eligibility": "Kelpoisuus",
        "nice_to_have": "Toivottava",
        "job_preview": "Realistinen työnkuva",
        "assessment": "Arviointi",
        "information": "Tiedonkeruu"
      },
      "categoryDescriptions": {
        "eligibility": "Kyllä/ei-kysymykset pakollisista vaatimuksista",
        "nice_to_have": "Kyllä/ei-kysymykset toivotuista mutta ei pakollisista pätevyyksistä",
        "job_preview": "Nostaa esiin roolin haastavan puolen. Auttaa varmistamaan, että hakija ymmärtää roolin sisällön ja vähentää vaihtuvuutta",
        "assessment": "Käyttäytymis- ja osaamiskysymykset",
        "information": "Taustatietojen kerääminen — ei käytetä pisteyttämiseen"
      },
      "categoryPurpose": {
        "eligibility": "Hyväksytty tai hylätty",
        "job_preview": "Hyväksytty tai hylätty",

        "assessment": "Pisteytetty",
        "information": "Vain tiedoksi"
      },
      "optional": "Valinnainen",
      "competency": "Osaaminen",
      "scoringExamples": "Pisteytysankkurit",
      "editScoringExamples": "Muokkaa pisteytysankkureita",
      "regenerateScoringExamples": "Generoi pisteytysankkurit uudelleen",
      "dontRegenerateScoringExamples": "Älä generoi pisteytysankkureita uudelleen",
      "regeneratingScoringExamples": "Generoidaan uudelleen...",
      "regenerateScoringError": "Pisteytysankkureiden uudelleengenerointi epäonnistui",
      "score1": "Pisteet 1 — Heikko",
      "score3": "Pisteet 3 — Riittävä",
      "score5": "Pisteet 5 — Erinomainen",
      "aiGenerated": "AI-generoitu"
    },
    "confirm": {
      "title": "Valmis aktivoitavaksi",
      "jobsCount": "{{count}} työpaikkaa aktivoidaan",
      "questionsCount": "{{count}} haastattelukysymystä",
      "modality": "Muoto",
      "languages": "Kielet",
      "goLiveHint": "Hakijat voivat aloittaa haastattelut heti aktivoinnin jälkeen."
    }
  },
  "login": {
    "title": "Kirjaudu Kikuun",
    "subtitle": "Hallinnoi rekrytointiprosessiasi.",
    "cta": "Kirjaudu sisään",
    "waitingForLogin": "Odotetaan kirjautumista…",
    "disclosure": "Olet vuorovaikutuksessa AI-järjestelmän kanssa. Kiku käyttää AI:ta rekrytoinnin apuna — kaikki päätökset tarkistetaan ihmisen toimesta.",
    "errors": {
      "not_provisioned": "Tiliäsi ei ole vielä määritetty. Ota yhteyttä ylläpitäjään.",
      "missing_code": "Todentaminen epäonnistui. Yritä uudelleen.",
      "session_expired": "Istuntosi on vanhentunut. Kirjaudu sisään uudelleen."
    }
  },
  "settings": {
    "profile": {
      "title": "Profiili",
      "name": "Nimi",
      "email": "Sähköposti",
      "role": "Rooli",
      "departments": "Osastot"
    }
  },
  "integrations": {
    "title": "Integraatiot",
    "ats": {
      "title": "ATS-yhteys",
      "description": "Yhdistä hakijaseurantajärjestelmäsi synkronoidaksesi työpaikat ja hallitaksesi hakijavaiheita.",
      "provider": "Palveluntarjoaja",
      "apiKey": "API-avain",
      "apiKeyPlaceholder": "Syötä API-avaimesi",
      "apiKeySet": "Avain tallennettu — syötä uusi arvo korvataksesi sen",
      "save": "Tallenna yhteys",
      "verify": "Vahvista yhteys",
      "verifyStatus": {
        "valid": "Yhdistetty",
        "invalid": "Virheellinen avain",
        "error": "Vahvistus epäonnistui",
        "idle": "Ei vahvistettu",
        "loading": "Vahvistetaan..."
      },
      "providers": {
        "teamtailor": "Teamtailor",
        "recman": "RecMan",
        "logicmelon": "LogicMelon",
        "teamtailorDescription": "Teamtailor on rekrytointialusta, joka auttaa yrityksiä houkuttelemaan, kehittämään ja palkkaamaan huippuosaajia.",
        "recmanDescription": "RecMan on rekrytointijärjestelmä henkilöstö- ja rekrytointitoimistoille Pohjoismaiden markkinoilla.",
        "logicmelonDescription": "LogicMelon on monipostaus-ATS suurivolyymiseen rekrytointiin, suosittu Yhdistyneen kuningaskunnan koulutussektorilla."
      }
    },
    "stageMapping": {
      "title": "Vaiheiden yhdistäminen",
      "description": "Yhdistä ATS-vaiheeseesi Kiku-työnkulun vaiheisiin.",
      "initialStage": "Alkuvaihe",
      "passInterviewStage": "Haastattelu hyväksytty",
      "failInterviewStage": "Haastattelu hylätty",
      "recommendedStage": "Suositeltu",
      "selectStage": "Valitse vaihe",
      "save": "Tallenna yhdistäminen"
    },
    "errors": {
      "notConfigured": "ATS-järjestelmää ei ole määritetty. Tallenna yhteys ensin.",
      "fetchStagesFailed": "Vaiheiden lataaminen ATS-järjestelmästä epäonnistui.",
      "saveFailed": "Asetusten tallentaminen epäonnistui."
    }
  },
  "applications": {
    "title": "Hakemukset",
    "newCandidate": "Uusi hakija",
    "addCandidate": "Lisää uusi hakija",
    "importFromCsv": "Tuo CSV-tiedostosta",
    "importDialog": {
      "title": "Tuo hakijoita",
      "back": "Takaisin",
      "next": "Seuraava",
      "upload": {
        "hint": "Vedä ja pudota CSV-tiedosto tähän tai selaa tiedostoja",
        "csvOnly": "Vain CSV-tiedostot",
        "browse": "Selaa"
      },
      "mapping": {
        "headerRow": "Ensimmäinen rivi on otsikkorivi",
        "nameColumn": "Nimisarake",
        "emailColumn": "Sähköpostisarake",
        "phoneColumn": "Puhelinsarake",
        "notMapped": "— ei yhdistetty —",
        "column": "Sarake",
        "preview": "Esikatselu"
      },
      "review": {
        "allValid": "Kaikki {{count}} hakijaa ovat kelvollisia",
        "summary": "{{valid}} kelvollista · {{invalid}} virheellistä",
        "skipInvalid": "Ohita virheelliset rivit ja tuo {{count}} kelvollista hakijaa",
        "recheck": "Tarkista uudelleen",
        "import": "Tuo {{count}} hakijaa",
        "colName": "Nimi",
        "colEmail": "Sähköposti",
        "colPhone": "Puhelin",
        "colStatus": "Tila"
      },
      "errors": {
        "nameRequired": "Pakollinen",
        "emailInvalid": "Virheellinen sähköposti",
        "emailDuplicate": "Sama sähköposti tässä tiedostossa",
        "phoneInvalid": "Maatunnus vaaditaan (esim. +358…)"
      },
      "success": {
        "title": "Tuonti valmis",
        "body": "{{created}} tuotu, {{conflict}} hakijalla oli jo hakemus (ohitettu), {{error}} epäonnistui.",
        "done": "Valmis"
      }
    },
    "screening": "Seulonta",
    "aiRanked": "AI-järjestetty",
    "emptyStage": "Ei hakemuksia",
    "emptyTitle": "Ei hakijoita vielä",
    "emptyDescription": "Lisää ensimmäinen hakija aloittaaksesi hakemusten tarkastelun.",
    "emptySearchDescription": "Yksikään hakija ei vastaa hakuasi.",
    "searchPlaceholder": "Hae nimellä, sähköpostilla tai puhelinnumerolla",
    "createDialog": {
      "title": "Lisää hakemus",
      "name": "Koko nimi",
      "namePlaceholder": "esim. Matti Meikäläinen",
      "email": "Sähköpostiosoite",
      "emailPlaceholder": "esim. matti@esimerkki.fi",
      "phoneNumber": "Puhelinnumero",
      "phoneNumberPlaceholder": "esim. 040-1234567",
      "phoneCountryCode": "Maatunnus",
      "phoneCountryCodePlaceholder": "esim. +358",
      "submit": "Luo hakemus"
    },
    "errors": {
      "conflict": "Tällä hakijalla on jo hakemus tähän työpaikkaan."
    },
    "detail": {
      "title": "Hakemuksen tiedot",
      "tabs": {
        "application": "Hakemus",
        "profile": "Profiili",
        "activity": "Toiminta"
      },
      "stage": "Vaihe",
      "interviewLink": "Haastattelulinkki",
      "interviewStatus": "Haastattelun tila",
      "copyLink": "Kopioi linkki",
      "linkCopied": "Kopioitu!",
      "noInterview": "Haastatteluistuntoa ei löytynyt",
      "noResults": {
        "title": "Haastattelua ei suoritettu",
        "description": "Tämä hakija ei ole vielä suorittanut haastattelua. Jaa haastattelulinkki aloittaaksesi."
      },
      "inProgress": {
        "title": "Haastattelu käynnissä",
        "description": "Tämä hakija on aloittanut haastattelun. Tulokset näkyvät tässä, kun se on valmis."
      },
      "openInterview": "Avaa haastattelu",
      "commChannel": {
        "label": "Lähetä kautta",
        "manual": "Manuaalinen",
        "email": "Sähköposti",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "status": {
        "pending": "Odottaa",
        "in_progress": "Käynnissä",
        "completed": "Valmis",
        "expired": "Vanhentunut"
      }
    }
  },
  "pagination": {
    "rowsPerPage": "Rivejä per sivu",
    "rowsSelected": "{{count}}/{{total}} riviä valittu.",
    "pageOf": "Sivu {{page}}/{{total}}",
    "previous": "Edellinen",
    "next": "Seuraava"
  },
  "screening": {
    "title": "Seulontahaastattelu",
    "aiDisclosure": "Keskustelet Saran kanssa, joka on AI-rekrytointiassistentti",
    "selectLanguage": "Valitse kieli",
    "selectLanguageDescription": "Haastattelu suoritetaan valitsemallasi kielellä",
    "startInterview": "Aloita haastattelu",
    "previewJobTitle": "Esimerkkityöpaikka — Esimerkkiyritys",
    "typeMessage": "Kirjoita viestisi...",
    "send": "Lähetä",
    "typing": "Sara kirjoittaa...",
    "submitInterview": "Lähetä haastattelu",
    "loading": "Ladataan haastattelua...",
    "completed": {
      "title": "Haastattelu suoritettu",
      "submitted": "Haastattelu lähetetty onnistuneesti",
      "message": "Kiitos haastattelun suorittamisesta tehtävään {{jobTitle}}. Rekrytoija tarkistaa vastauksesi ja on yhteydessä."
    },
    "expired": {
      "title": "Haastattelu vanhentunut",
      "message": "Tämä haastattelulinkki on vanhentunut. Ota yhteyttä rekrytoijaan saadaksesi uuden kutsun."
    },
    "notFound": {
      "title": "Haastattelua ei löytynyt",
      "message": "Tämä haastattelulinkki ei ole kelvollinen. Tarkista linkki ja yritä uudelleen."
    },
    "feedback": {
      "helpUsImprove": "Auta meitä kehittymään",
      "teaser": "Millainen haastattelukokemus oli?",
      "overallPrompt": "Millainen haastattelukokemus oli kokonaisuudessaan?",
      "disclaimer": "Haluaisimme palautettasi — se on anonyymiä eikä vaikuta hakemukseesi.",
      "prompt": "Miten haastattelu sujui?",
      "good": "Hyvin",
      "bad": "Huonosti",
      "notesLabel": "Haluatko lisätä jotain?",
      "notesPlaceholder": "Kerro lisää (valinnainen)...",
      "skip": "Ohita",
      "submit": "Lähetä palaute",
      "submitError": "Palautteen lähettäminen epäonnistui. Yritä uudelleen."
    },
    "technicalIssue": {
      "buttonLabel": "Tekninen ongelma?",
      "modalTitle": "Ilmoita teknisestä ongelmasta",
      "modalDescription": "Kuvaile kohtaamasi ongelma. Palautteesi lähetetään ja haastattelu käynnistetään uudelleen.",
      "notesLabel": "Mikä meni pieleen?",
      "notesPlaceholder": "esim. Sivu jäätyi ja edistymiseni katosi...",
      "submitButton": "Lähetä palaute ja käynnistä uudelleen",
      "submitError": "Lähettäminen epäonnistui. Yritä uudelleen.",
      "cancel": "Peruuta"
    },
    "error": {
      "title": "Jokin meni pieleen",
      "message": "Tapahtui virhe. Yritä myöhemmin uudelleen.",
      "sendFailed": "Viestin lähettäminen epäonnistui. Yritä uudelleen."
    },
    "languages": {
      "en": "Englanti",
      "da": "Tanska",
      "sv": "Ruotsi",
      "de": "Saksa",
      "fr": "Ranska",
      "es": "Espanja",
      "nl": "Hollanti",
      "pl": "Puola",
      "fi": "Suomi",
      "ro": "Romania"
    },
    "landing": {
      "badge": "TYÖHAASTATTELU",
      "greeting": "Hei {{name}}! Mukavaa, että olet täällä. Tämä on kutsu nopeaan online-seulontahaastatteluun AI:n kanssa, jotta voimme tutustua sinuun. Aloita, kun olet valmis.",
      "startChat": "Aloita chat-haastattelu",
      "startVoice": "Aloita puhehaastattelu",
      "or": "tai",
      "minutes": "{{count}} minuuttia",
      "questions": "{{count}} kysymystä"
    },
    "modality": {
      "title": "Valitse haastattelumuoto",
      "description": "Valitse, miten haluat suorittaa haastattelun",
      "text": "Tekstihaastattelu",
      "textDescription": "Kirjoita vastauksesi chatissa",
      "voice": "Puhehaastattelu",
      "voiceDescription": "Vastaa puhumalla ääneen"
    },
    "deviceTest": {
      "title": "Tarkista ääni",
      "description": "Varmista, että mikrofoni ja kaiuttimet toimivat ennen aloittamista",
      "microphone": "Mikrofoni",
      "speakers": "Kaiuttimet",
      "testMicrophone": "Salli mikrofonin käyttö",
      "testSpeakers": "Toista testääni",
      "playAgain": "Toista uudelleen",
      "requestingPermission": "Pyydetään lupaa...",
      "microphoneDenied": "Mikrofonin käyttö evättiin. Salli käyttö selaimen asetuksista.",
      "confirm": "Kaikki toimii — aloita haastattelu"
    },
    "voice": {
      "title": "Puhehaastattelu",
      "connecting": "Yhdistetään...",
      "recording": "Nauhoitetaan",
      "interviewInProgress": "Haastattelu käynnissä",
      "inProgress": "Haastattelu käynnissä — puhu luonnollisesti",
      "muted": "Mikrofonisi on mykistetty",
      "finished": "Haastattelu valmis — kiitos!",
      "alreadyInProgress": "Haastattelu käynnissä",
      "alreadyInProgressMessage": "Puhehaastattelusi on tällä hetkellä aktiivinen. Uudelleenkäynnistys peruuttaa nykyisen istunnon — tee tämä vain, jos et ole enää yhteydessä.",
      "retryButton": "Käynnistä haastattelu uudelleen"
    }
  },
  "scoring": {
    "title": "Haastattelutulokset",
    "pending": "Pisteytys käynnissä...",
    "processing": "AI arvioi haastattelua...",
    "failed": "Pisteytys epäonnistui",
    "overallScore": "Kokonaispisteet",
    "overallScoreTooltip": "Pisteet 0–100 perustuen kaikkien arviointikysymysten keskiarvoon, oikaistuna kelpoisuuden ja työn odotusten perusteella.",
    "outcome": "Tulos",
    "outcomes": {
      "pass": "Hyväksytty",
      "fail": "Hylätty"
    },
    "summary": "Yhteenveto",
    "eligibility": "Kelpoisuus",
    "niceToHave": "Toivottava",
    "expectations": "Työn odotukset",
    "assessment": "Arviointi",
    "information": "Tiedonkeruu",
    "scoringAnchors": "Pisteytysankkurit",
    "candidateAnswer": "Hakijan vastaus",
    "transcript": "Haastattelun litterointi",
    "viewInTranscript": "Näytä litteroinnissa",
    "copyPasteDetected": "Kopioitu ja liitetty vastaus",
    "copyPasteWarning": "Kopiointi ja liittäminen havaittu tässä haastattelussa",
    "copyPasteWarningTooltip": "Yksi tai useampi hakijan vastaus liitettiin haastattelun aikana. Tämä voi viitata siihen, että hakija käytti ennalta kirjoitettuja vastauksia.",
    "verdicts": {
      "pass": "Hyväksytty",
      "fail": "Hylätty",
      "unsure": "Epävarma",
      "review": "Tarkistettava"
    },
    "optional": "Valinnainen",
    "averageScore": "Kysymysten keskipisteet",
    "reasoning": "Perustelu",
    "evidence": "Todisteet",
    "backToJob": "Takaisin työpaikkaan",
    "overrideDialog": {
      "title": "Ohita pisteet",
      "titleVerdict": "Ohita arvio",
      "currentValue": "Nykyinen arvo",
      "newValue": "Uusi arvo",
      "reason": "Ohituksen syy",
      "reasonPlaceholder": "Selitä, miksi muutat tätä pisteitystä...",
      "reasonMinLength": "Vähintään {{min}} merkkiä vaaditaan",
      "save": "Tallenna ohitus",
      "cancel": "Peruuta",
      "error": "Ohituksen tallentaminen epäonnistui. Yritä uudelleen."
    }
  },
  "workflows": {
    "title": "Työnkulku",
    "description": "Määritä vaiheet, joiden läpi hakemukset etenevät rekrytointiprosessissa.",
    "stages": {
      "title": "Prosessivaiheet",
      "subtitle": "Vedä järjestääksesi uudelleen. Hakemukset etenevät näiden vaiheiden läpi ylhäältä alas.",
      "system": "Järjestelmä",
      "manage": "Hallitse vaiheita",
      "addStage": "Lisää vaihe",
      "editStage": "Muokkaa vaihetta",
      "deleteStage": "Poista vaihe",
      "stageName": "Vaiheen nimi",
      "stageNamePlaceholder": "esim. Puhelinkeskustelu",
      "stageColor": "Väri",
      "deleteConfirm": "Poista tämä vaihe? Tässä vaiheessa olevat hakemukset täytyy siirtää ensin.",
      "systemProtected": "Järjestelmävaiheita ei voi poistaa",
      "hasApplications": "Tässä vaiheessa on vielä hakemuksia"
    }
  },
  "communications": {
    "title": "Agenttiviestintä",
    "languageSelector": "Kieli",
    "tabs": {
      "sms": "SMS",
      "email": "Sähköposti"
    },
    "emailSubject": "Aihe",
    "emailBody": "Sisältö",
    "variables": {
      "applicantName": "Hakijan nimi",
      "jobTitle": "Työpaikan otsikko",
      "jobEmployer": "Työnantaja",
      "jobLocation": "Sijainti",
      "jobDescription": "Työpaikkakuvaus",
      "recruiterName": "Rekrytoijan nimi",
      "inviteUrl": "Kutsulinkki"
    },
    "actions": {
      "edit": "Muokkaa",
      "save": "Tallenna muutokset",
      "reset": "Palauta oletukseksi",
      "saved": "Mallipohja tallennettu",
      "resetDone": "Palautettu oletusarvoon"
    },
    "nodes": {
      "interviewIntro": "Haastattelun avaus",
      "interviewOutro": "Haastattelun lopetus",
      "reminderToFinish": "Muistutus suorittamisesta",
      "voiceAndChat": "Puhe ja chat",
      "emailsAndSms": "Sähköpostit ja SMS",
      "comingSoon": "Tulossa pian"
    },
    "characters": "{{count}}/{{max}} merkkiä",
    "smsSegments": "{{count}} SMS-viestiä ({{size}} merkkiä/viesti)",
    "smsUnicodeWarning": "Tämä viesti sisältää emojeja tai erikoismerkkejä, jotka vaativat Unicode-koodauksen, mikä pienentää rajan 67 merkkiin per SMS.",
    "invite": {
      "title": "Hakijan kutsu",
      "description": "Hakijat saavat tämän, kun heidät lisätään työpaikkailmoitukseen. Sähköposti sisältää automaattisesti linkin haastatteluun.",
      "email": {
        "subject": "Sinut on kutsuttu {{jobTitle}}-haastatteluun! 🎯",
        "body": "<p>Hei {{applicantName}},</p><p>Sinut on kutsuttu suorittamaan nopea online-seulontahaastattelu AI-haastattelijamme kanssa tehtävään <strong>{{jobTitle}}</strong> yrityksessä <strong>{{jobEmployer}}</strong>.</p><p>Se on yksinkertainen tapa tutustua sinuun paremmin — suorita se milloin sinulle sopii, mistä tahansa. Se vie vain muutaman minuutin!</p><p><a href=\"{{inviteUrl}}\">Aloita haastattelu</a></p><p>Onnea!<br>{{jobEmployer}}</p>"
      },
      "sms": "Hei {{applicantName}}, olen Sara, {{jobEmployer}}n AI-työassistentti. Sinut on kutsuttu haastatteluun tehtävään {{jobTitle}}. Se vie vain muutaman minuutin: {{inviteUrl}} (Ei vastauksia)"
    },
    "reminder": {
      "title": "Haastattelumuistutus",
      "description": "Lähetetään automaattisesti, jos hakija ei ole aloittanut haastattelua 24 tunnin kuluessa kutsun saamisesta.",
      "email": {
        "subject": "Muista {{jobTitle}}-haastattelusi",
        "body": "<p>Hei {{applicantName}},</p><p>Huomasimme, ettet ole vielä suorittanut AI-seulontahaastattelua tehtävään <strong>{{jobTitle}}</strong> yrityksessä <strong>{{jobEmployer}}</strong>.</p><p>Tämä on tilaisuutesi päästä askeleen lähemmäs — se vie vain muutaman minuutin, ja sen suorittaminen parantaa mahdollisuuksiasi edetä seuraavaan vaiheeseen.</p><p><a href=\"{{inviteUrl}}\">Suorita haastattelu nyt</a></p><p>Ystävällisin terveisin,<br>{{jobEmployer}}</p>"
      },
      "sms": "Hei {{applicantName}}, ystävällinen muistutus — et ole vielä suorittanut {{jobTitle}}-haastattelua yrityksessä {{jobEmployer}}. Se vie vain muutaman minuutin ja parantaa mahdollisuuksiasi: {{inviteUrl}} — Sara"
    },
    "emailBodyPlaceholder": "Kirjoita sähköpostisi...",
    "preview": {
      "outroSampleIntro": "Siinä kaikki — kiitos vastauksistasi!",
      "outroSampleAnswer": "Ei kestä, autan mielelläni."
    },
    "intro": {
      "title": "Haastattelun avaus",
      "description": "Tarkka avausviesti, jonka Sara sanoo tervehtäessään hakijaa ja kysyessään, onko tämä valmis aloittamaan.",
      "scriptLabel": "Avausviesti",
      "scriptPlaceholder": "Kirjoita tarkka avausviesti, jonka Saran tulisi sanoa...",
      "defaultScript": "Hei! Olen Sara, AI-rekrytointiassistentti yritykselle {{jobEmployer}}. Kiitos, että käytät aikaa haastatteluun tehtävään {{jobTitle}} — se vie vain muutaman minuutin. Oletko valmis aloittamaan? 😊"
    },
    "outro": {
      "title": "Haastattelun lopetus",
      "description": "Tarkka lopetusviesti, jonka Sara sanoo kun kaikki kysymykset on vastattu.",
      "scriptLabel": "Lopetusviesti",
      "scriptPlaceholder": "Kirjoita tarkka lopetusviesti, jonka Saran tulisi sanoa...",
      "defaultScript": "Siinä kaikki — kiitos paljon ajastasi tänään! Rekrytoija tarkistaa vastauksesi ja on yhteydessä. Onnea! 🙂"
    }
  },
  "activity": {
    "title": "Toiminta",
    "stageChange": "Siirretty vaiheesta {{from}} vaiheeseen {{to}}",
    "interviewCompleted": "Seulontahaastattelu suoritettu",
    "scoreReceived": "Pisteet vastaanotettu: {{score}}/100",
    "applicationCreated": "Hakemus luotu",
    "noteAdded": "Muistiinpano lisätty",
    "bySystem": "Järjestelmä",
    "byAi": "AI",
    "empty": "Ei toimintaa vielä",
    "emptyTitle": "Ei toimintaa vielä",
    "emptyDescription": "Tämän hakijan toiminnot ja tapahtumat näkyvät täällä."
  },
  "atsPush": {
    "title": "ATS-lähetyksen tila",
    "retry": "Yritä ATS-lähetystä uudelleen",
    "retrying": "Yritetään uudelleen...",
    "rerunStep": "Suorita tämä vaihe uudelleen",
    "rerunConfirm": "Tämä vaihe onnistui jo. Uudelleensuoritus voi luoda päällekkäistä dataa ATS-järjestelmääsi. Jatketaanko?",
    "steps": {
      "transcript": "Litterointi",
      "stage_move": "Vaiheen siirto"
    },
    "status": {
      "completed": "Lähetetty",
      "failed": "Epäonnistui",
      "pending": "Odottaa"
    },
    "note": {
      "title": "AI-seulontahaastattelu",
      "outcome": "Tulos",
      "score": "Pisteet",
      "summary": "Yhteenveto",
      "eligibility": "Kelpoisuus",
      "assessment": "Arviointi",
      "transcript": "Litterointi",
      "candidate": "Hakija",
      "interviewer": "Haastattelija",
      "pass": "Hyväksytty",
      "fail": "Hylätty",
      "review": "Tarkistettava",
      "shortlist": "Esivalinta",
      "reject": "Hylkää",
      "viewProfile": "Näytä hakijan profiili Kikussa",
      "transcriptAndAssessment": "LITTEROINTI JA ARVIOINTI",
      "intro": "Avaus",
      "eligibilityQuestions": "Kelpoisuuskysymykset",
      "jobExpectations": "Työn odotukset",
      "assessmentQuestions": "Arviointikysymykset",
      "outro": "Lopetus",
      "assessmentExplanation": "ARVIOINNIN SELITYS",
      "unsure": "Epävarma",
      "viewInKiku": "KATSO KIKUSTA LISÄTIETOJA",
      "viewProfileLink": "Näytä hakijan profiili Kikussa nähdäksesi pisteiden selitykset"
    }
  },
  "topbar": {
    "whatsNew": "Uutta",
    "help": "Ohje",
    "notifications": "Ilmoitukset"
  },
  "extension_candidate_banner": {
    "description": "Näytä hakijan tiedot.",
    "description_with_transcript": "Näytä seulonnan litterointi ja hakijan tiedot.",
    "open_in_kiku": "Avaa",
    "dismiss": "Hylkää"
  },
  "languages": {
    "en": "Englanti",
    "da": "Tanska",
    "sv": "Ruotsi",
    "de": "Saksa",
    "fr": "Ranska",
    "es": "Espanja",
    "nl": "Hollanti",
    "pl": "Puola",
    "fi": "Suomi",
    "ro": "Romania"
  },
  "environmentBanner": {
    "development": "Kehitys",
    "test": "Testi"
  },
  "notFound": {
    "title": "Sivua ei löytynyt",
    "description": "Etsimääsi sivua ei ole olemassa tai se on siirretty.",
    "goHome": "Palaa Kikuun"
  },
  "candidateProfile": {
    "title": "Hakijat",
    "cv": {
      "title": "CV / Ansioluettelo",
      "upload": "Lataa CV",
      "replace": "Vaihda CV",
      "uploadDescription": "Lataa CV rakenteellisten profiilitietojen poimimiseksi",
      "uploadLimit": "Enintään 10 Mt — PDF, DOCX, PNG, JPG, WEBP",
      "viewOriginal": "Näytä alkuperäinen CV",
      "status": {
        "pending": "Jonossa",
        "processing": "Käsitellään...",
        "done": "Käsitelty",
        "failed": "Käsittely epäonnistui"
      },
      "parsed": {
        "title": "Poimittu profiili",
        "skills": "Taidot",
        "experience": "Kokemus",
        "education": "Koulutus",
        "languages": "Kielet",
        "certifications": "Sertifikaatit",
        "present": "Nykyinen"
      },
      "errors": {
        "unsupportedType": "Tiedostotyyppiä ei tueta. Lataa PDF, DOCX, PNG, JPG tai WEBP.",
        "tooLarge": "Tiedosto on liian suuri. Enimmäiskoko on 10 Mt.",
        "uploadFailed": "CV:n lataaminen epäonnistui. Yritä uudelleen."
      }
    }
  },
  "results": {
    "exportLabel": "Vie",
    "exportCsv": "Vie CSV",
    "csv": {
      "headers": {
        "candidateName": "Hakijan nimi",
        "email": "Sähköposti",
        "role": "Rooli",
        "stage": "Vaihe",
        "overallScore": "Kokonaispisteet",
        "outcome": "Tulos",
        "eligibility": "Kelpoisuus",
        "expectations": "Odotukset",
        "avgScore": "Keskipisteet",
        "interviewDate": "Haastattelupäivä",
        "status": "Tila"
      }
    },
    "emptyTitle": "Ei tuloksia vielä",
    "emptyDescription": "Suoritetut haastattelut näkyvät täällä.",
    "columns": {
      "candidate": "Hakija",
      "stage": "Vaihe",
      "status": "Tila",
      "score": "Pisteet",
      "outcome": "Tulos",
      "eligibility": "Kelpoisuus",
      "expectations": "Odotukset",
      "avgScore": "Keskipisteet",
      "interviewDate": "Haastattelupäivä",
      "question": "Kysymys"
    },
    "statusLabels": {
      "pending": "Odottaa",
      "processing": "Käsitellään",
      "completed": "Valmis",
      "failed": "Epäonnistui",
      "no_interview": "Ei haastattelua"
    },
    "questionSections": {
      "eligibility": "Kelpoisuus",
      "job_preview": "Odotukset",
      "nice_to_have": "Toivottava",
      "assessment": "Arviointi",
      "information": "Tiedot"
    },
    "fields": {
      "reasoning": "Perustelu",
      "evidence": "Todisteet",
      "response": "Vastaus",
      "avgScoreLabel": "Keskipisteet",
      "interviewDate": "Haastattelupäivä"
    }
  },
  "orgSettings": {
    "title": "Organisaation asetukset",
    "branding": {
      "title": "Brändi",
      "logo": "Organisaation logo",
      "logoDescription": "Lataa logo korvataksesi oletusarvoisen Kiku-logon navigointipalkissa.",
      "uploadLogo": "Lataa logo",
      "removeLogo": "Poista logo",
      "logoHint": "PNG, JPG, WebP tai SVG. Enintään 2 Mt.",
      "uploadSuccess": "Logo päivitetty onnistuneesti",
      "removeSuccess": "Logo poistettu",
      "uploadError": "Logon lataaminen epäonnistui"
    },
    "timezone": {
      "title": "Aikavyöhyke",
      "description": "Aseta oletusaikavyöhyke aikataulutukseen ja päivämäärien näyttämiseen.",
      "label": "Aikavyöhyke",
      "saveSuccess": "Aikavyöhyke päivitetty",
      "saveError": "Aikavyöhykkeen päivittäminen epäonnistui"
    },
    "save": "Tallenna muutokset"
  },
  "mcp": {
    "title": "MCP-integraatio",
    "subtitle": "Yhdistä AI-assistentit Kikuun Model Context Protocolin kautta",
    "whatIsMcp": "Mikä on MCP?",
    "whatIsMcpDescription": "Model Context Protocol (MCP) mahdollistaa AI-assistenttien, kuten Claude, ChatGPT ja muiden työkalujen, vuorovaikutuksen suoraan Kikun kanssa — työpaikkojen listaamisen, hakijoiden tarkastelun ja rekrytointiprosessin hallinnan luonnollisella kielellä.",
    "serverUrl": "Palvelimen URL",
    "copyUrl": "Kopioi URL",
    "copied": "Kopioitu!",
    "availableTools": "Saatavilla olevat työkalut",
    "toolListJobs": "Hae ja listaa työpaikkailmoituksia osastonimillä, suodattimilla statukselle, asetusstatukselle ja osastolle.",
    "toolGetJob": "Hae tietyn työpaikkailmoituksen kaikki tiedot, mukaan lukien osaston nimi.",
    "toolCreateJob": "Luo uusi työpaikkailmoitus osastolle.",
    "toolAdvanceSetup": "Siirrä työpaikka asetusvaiheiden läpi (luonnos, kysymykset odottavat, valmis, aktiivinen).",
    "toolListApplications": "Listaa hakemukset työpaikkaan vaihenimillä, pisteytysstatuksella ja tuloksella.",
    "toolGetInterviewResults": "Hae tekoälyhaastattelun tulokset hakemukselle — pisteet, tulos ja kysymyskohtainen erittely perusteluineen.",
    "toolGetPipelineSummary": "Hae pipeline-yhteenveto työpaikalle — hakijamäärät vaiheittain hyväksyttyjen/hylättyjen kokonaismäärillä.",
    "setupTitle": "Asennus Claude Desktopilla",
    "setupStep1": "Avaa Claude Desktop",
    "setupStep2": "Napsauta Customize vasemmassa sivupalkissa",
    "setupStep3": "Napsauta Connectors, sitten +-kuvaketta, sitten Add custom connector",
    "setupStep4": "Syötä Name: Kiku ja yllä näkyvä palvelimen URL",
    "setupStep5": "Napsauta Add — Claude voi nyt käyttää Kiku-tietojasi"
  }
}
